import { render, staticRenderFns } from "./MyPickup.vue?vue&type=template&id=6000bde5&scoped=true&"
import script from "./MyPickup.vue?vue&type=script&lang=js&"
export * from "./MyPickup.vue?vue&type=script&lang=js&"
import style0 from "./MyPickup.vue?vue&type=style&index=0&id=6000bde5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000bde5",
  null
  
)

component.options.__file = "MyPickup.vue"
export default component.exports